import { CapIcon } from 'foundations-assets/icons/components/CapIcon';
import { MarketplaceIcon } from 'foundations-assets/icons/components/MarketplaceIcon';

/**
 * Add a custom Trellis icon for HubSpot.com routes.
 *
 * Example: { slug: 'marketplace', icon: MarketplaceIcon }
 *  Shows the MarketplaceIcon for hubspot.com/marketplace/ website citations.
 */
export const HUBSPOT_WEB_CITATION_ICON_MAP = [{
  slug: 'academy',
  icon: CapIcon
}, {
  slug: 'marketplace',
  icon: MarketplaceIcon
}];